import axios from '../axios'
import { formatSelectOption as format, promiseAll } from '@/utils'
const cache = {}

// 申诉年度 期次
export const getAppealYearAndPeriod = data => {
  if (cache.period) return cache.period
  return (cache.period = axios.post('/select/Appealtimeperiod', data, { loading: 'timeperiod' }).then(
    ({ data = {} }) => {
      const rows = data.data || {}
      const year = format(rows.year)
      const period = format(rows.period)
      return { year, period }
    },
    err => {
      console.error(err)
      cache.period = null
    }
  ))
}

// 年度 期次
export const getYearAndPeriod = data => {
  if (cache.period) return cache.period
  return (cache.period = axios.post('/select/timeperiod', data, { loading: 'timeperiod' }).then(
    ({ data = {} }) => {
      const rows = data.data || {}
      const year = format(rows.year)
      const period = format(rows.period)
      return { year, period }
    },
    err => {
      console.error(err)
      cache.period = null
    }
  ))
}

// 业务类型
export const getBusinessType = data => {
  if (cache.business) return cache.business
  return (cache.business = axios.post('/select/businesstype', data, { loading: 'businesstype' }).then(
    ({ data = {} }) => format(data.data),
    err => {
      cache.business = null
    }
  ))
}

// 任务代码
export const getTaskCode = (data, needCache = true) => {
  if (cache.taskcode && needCache) return cache.taskcode
  return (cache.taskcode = axios.post('/select/taskcode', data, { loading: 'taskcode' }).then(
    ({ data = {} }) => format(data.data),
    err => {
      console.error(err)
      cache.taskcode = null
    }
  ))
}

// 子任务类型
export const getChildTaskTypeAndName = ({ year, period, business_id, child_task_type }, cancel = 'select.childtaskname') => {
  return axios.post('/select/chaildtasktype', { year, period, business_id, child_task_type }, { loading: 'childtasktypeandname', cancel }).then(({ data = {} }) => {
    const { child_task_name_arr: taskName, child_task_type_arr: taskType, collect_status_arr: collect_status, shenhestatus_arr: shenhestatus } = data.data || {}
    return {
      taskName: format(taskName),
      taskType: format(taskType),
      collect_status: format(collect_status),
      shenhestatus: format(shenhestatus)
    }
  })
}

// 轮次
export const getTaskRounds = data => axios.post('/select/round', data, { loading: 'taskrounds' }).then(({ data = {} }) => format(data.data))

// 特殊情况处理状态、特殊情况处理结果、特殊情况提报状态
export const getSpecialSelect = data => {
  return axios.post('/select/specialselect', data, { loading: 'specialselect' }).then(
    ({ data = {} }) => {
      const { result, status, special_status } = data.data || {}
      return {
        result: format(result, 'value'),
        status: format(status, 'value'),
        special_status: format(special_status, 'value')
      }
    })
}
/**
 * 文件参数
 */
export const getSystemFileParamsData = data=> axios.post('/bzmj/admin/system/select/common',data, { timeout: 60 * 1000, loading: 'select' }).then(({ data = {} }) => {
  const { month, report_from, audio_type, status, year } = data.data || {}
  return {
    period: format(month),
    report_from: format(report_from),
    audio_type: format(audio_type),
    status: format(status),
    year: format(year)
  }
})
// 任务状态、结果发布状态、检核状态、采集状态、审核状态
export const getCollectStatusMany = data => {
  if (cache.collectstatus) return cache.collectstatus
  return (cache.collectstatus = axios.post('/select/collectSelect', data, { loading: 'collectstatus' }).then(
    ({ data }) => {
      const { task_status: task, res_push_status: push, jianhe_status: check, gather_status: gather, res_status: result, check_status, qustion_type_arr, jx_code_arr } =
        data.data || {}
      return {
        task: format(task),
        push: format(push),
        check: format(check),
        gather: format(gather),
        result: format(result),
        check_status: format(check_status),
        question_type: format(qustion_type_arr),
        jx: format(jx_code_arr)
      }
    },
    err => {
      console.error(err)
      cache.collectstatus = null
    }
  ))
}

// 异常运营处理状态、判定结果、异常运营类型、提报状态、异常运营状态
export const getAbnormalSelect = data => {
  if (cache.abnormalselect) return cache.abnormalselect
  return (cache.abnormalselect = axios.post('/select/abnormalSelect', data, { loading: 'abnormalselect' }).then(
    ({ data }) => {
      const { abnormal_dispose_status, abnormal_dispose_res, abnormal, submit_abnormal_status, abnormal_status } = data.data || {}
      const dispose = abnormal_dispose_status || []
      const result = abnormal_dispose_res || []
      const category = abnormal || []
      const submit = submit_abnormal_status || []
      const status = abnormal_status || []
      return {
        status: format(status, 'value'), // 运营状态
        result: format(result, 'value'), // 判定结果
        category: format(category, 'value'), // 异常类型
        submit: format(submit, 'value'), // 提报状态
        dispose: format(dispose, 'value') // 处理状态
      }
    },
    err => {
      console.error(err)
      cache.abnormalselect = null
    }
  ))
}

/**
 * 战区列表
 * @param {number} business_type_id 业务类型id
 */
const loadDaquList = id =>
  axios.post('/jkd/home/dropdown/selectDaqu', { business_type_id: id }, { loading: 'daquselect' }).then(({ data }) => format(data.data, 'daqu_name'))
export const getDaquList = id => {
  if (id) return loadDaquList(id)
  return getBusinessType().then(data => {
    const { value } = data[0] || {}
    return loadDaquList(value)
  })
}

/**
 * 小区列表
 * @param {number} business_type_id 业务类型id
 * @param {number} daqu_id
 */
const loadXiaoquList = (id, daqu_id) =>
  axios
    .post('/jkd/home/dropdown/selectXiaoqu', { business_type_id: id, daqu_id }, { loading: 'xiaoquselect', cancel: 'select.xiaoqu' })
    .then(({ data }) => format(data.data, 'xiaoqu_name'))
export const getXiaoquList = (id, daqu_id) => {
  if (!daqu_id) return Promise.resolve([])
  if (id) return loadXiaoquList(id, daqu_id)
  return getBusinessType().then(data => {
    const { value } = data[0] || {}
    return loadXiaoquList(value, daqu_id)
  })
}

/**
 * 门店列表
 * @param {number} id
 * @param {number} xiaoqu_id
 */
export const loadDealerList = (id, xiaoqu_id) =>
  axios
    .post('/jkd/home/dropdown/selectDealer', { business_type_id: id, xiaoqu_id }, { loading: 'dealerselect', cancel: 'select.dealer' })
    .then(({ data = {} }) => format(data.data, 'dealer_shortname'))
export const getDealerList = (id, xiaoqu_id) => {
  if (!xiaoqu_id) return Promise.resolve([])
  if (id) return loadDealerList(id, xiaoqu_id)
  return getBusinessType().then(data => {
    const { value } = data[0] || {}
    return loadDealerList(value, xiaoqu_id)
  })
}
/**
 * 任务名称
 */
export const getTaskName = data => axios.post('/select/tasknameSelect', data, { loading: 'tasknameSelect' }).then(({ data = {} }) => format(data.data, 'value'))

/**
 * 申诉状态、申诉结果
 */
export const getAppealSelect = data => {
  if (cache.appealselect && !data) return cache.appealselect
  return (cache.appealselect = axios.post('/select/appealSelect', data, { loading: 'appealselect' }).then(
    ({ data = {} }) => {
      const { appeal_status, appeal_result, appeal_deal,appeal_final_status } = data.data || {}
      return {
        status: format(appeal_status, 'value'),
        result: format(appeal_result, 'value'),
        dispose: format(appeal_deal, 'value'),
        final_status: format(appeal_final_status, 'value')
      }
    },
    err => {
      console.error(err)
      cache.appealselect = null
    }
  ))
}

/**
 * 人员登记下拉
 */
cache.personselect = {}
export const getPersonSelect = (id, business_id) => {
  const key = `${business_id || 0}_${id || 0}`
  if (cache.personselect[key]) return cache.personselect[key]
  return (cache.personselect[key] = promiseAll([
    axios.post('/select/personstatus', {}, { loading: 'personstatus' }),
    axios.post('/moblie/select/station/status', {}, { loading: 'stationstatus' }),
    axios.post('/moblie/select/station/name', { issue_child_task_dealer_id: id, business_id }, { loading: 'stationname' })
  ]).then(([personstatus = {}, stationstatus = {}, stationname = {}]) => {
    if (!(personstatus && stationstatus && stationname)) {
      cache.personselect[key] = null
    }
    const pdata = personstatus.data || {}
    const sdata = stationstatus.data || {}
    const stationName = stationname.data || {}
    const { caiji_status, dms_status, station_type, shenhe_status: audit, person_status: result } = pdata.data || {}
    return {
      dms: format(dms_status), // DMS备案状态
      status: format(caiji_status), // 登记状态
      stationType: format(station_type), // 岗位状态
      audit: format(audit), // 审核状态
      stationStatus: format(sdata.data),
      result: format(result), // 人员审核结果
      stationName: format(stationName.data)
    }
  }, () => (cache.personselect[key] = null)))
}

export const getRoles = () => {
  if (cache.roles) return cache.roles
  return (cache.roles = axios.post('/select/userroles', {}, { loading: 'roleselect' }).then(
    ({ data = {} }) => format(data.data || [], 'value'),
    () => {
      cache.roles = null
    }
  ))
}

/**
 * 模块、子模块
 */
cache.module = {}
export const getModules = (business_id, id, child_task_type, check_type) => {
  const key = `${business_id || 0}_${child_task_type || 0}_${id || 0}_${check_type || ''}`
  if (cache.module[key]) return cache.module[key]
  return (cache.module[key] = axios.post('/select/modulesAudits', { business_id, id, child_task_type, check_type }, { loading: 'moduleselect', cancel: `moduleselect-${key}` }).then(
    ({ data = {} }) => {
      const rows = data.data || []
      const modules = []
      const childModule = []
      rows.forEach(({ module, child_modules = [] }) => {
        modules.push({ label: module, value: module })
        const child = child_modules.map(label => ({ label, module, value: label }))
        childModule.push(...child)
      })
      return { modules, childModule }
    },
    () => (cache.module[key] = null)
  ))
}

/**
 * 审计项目
 */
export const getAuditItem = data =>
  axios.post('/select/audits', data, { loading: 'auditselect', cancel: 'select.audititem' }).then(({ data = {} }) => format(data.data))

/**
 * 下发状态
 */
export const getIssueStatus = () => {
  if (cache.issue) return cache.issue
  return (cache.issue = axios.post('/select/taskstaus', {}, { loading: 'issueselect' }).then(({ data = {} }) => format(data.data), () => (cache.issue = null)))
}
